import { Box, Typography } from "@mui/material";
import { TablePlaceHolder } from "@app/components/PlaceHolder";
import { memo } from "react";
import { CarPageContentCode, usePageContent } from "@app/hooks/usePageContent";
import { CarPageContent } from "@app/components/PageContent";
import { CarAssetClassSelector } from "@app/components/AssetClassSelector";
import { ChartIndexCompare } from "@app/components/ChartIndexCompare";
import { TableIndexCompare } from "@app/components/TableIndexCompare";
import { useSimulationModelsIndexCompare } from "./useSimulationModelsIndexCompare";
import { InternalUse } from "../assetAllocation/editPortfolioGroup/InternalUse";
import { formatDate } from "@app/utils";

export const SimulationModelsIndexCompare = memo(() => {
  const data = useSimulationModelsIndexCompare({
    storageKey: "SimulationModelsIndexCompare",
  });

  const pageContent = usePageContent();

  return (
    <TablePlaceHolder
      isLoading={data.isLoading || pageContent.isLoading}
      rows={8}
    >
      <CarPageContent
        sx={{ mt: 3 }}
        isWhiteContext
        content={pageContent.getContent(
          CarPageContentCode.SIMULATION_ANALYSIS_MODELS_INDEX_COMPARE,
        )}
      />

      <Box
        sx={{
          mt: 5,
          mb: 3,
          display: "flex",
          alignItems: "flex-end",
          gap: 5,
        }}
      >
        <CarAssetClassSelector
          label="Asset Class 1"
          sx={{
            width: 250,
            ".MuiInputBase-root": {
              backgroundColor: "white",
            },
          }}
          items={data.items}
          valueField="level4Id"
          value={data.chartDataSelector.data1Id}
          onChange={data.chartDataSelector.onData1IdChange}
        />
        <CarAssetClassSelector
          label="Asset Class 2"
          sx={{
            width: 250,
            ".MuiInputBase-root": {
              backgroundColor: "white",
            },
          }}
          items={data.items}
          valueField="level4Id"
          value={data.chartDataSelector.data2Id}
          onChange={data.chartDataSelector.onData2IdChange}
        />
        <CarAssetClassSelector
          label="Asset Class 3"
          sx={{
            width: 250,
            ".MuiInputBase-root": {
              backgroundColor: "white",
            },
          }}
          items={data.items}
          valueField="level4Id"
          value={data.chartDataSelector.data3Id}
          onChange={data.chartDataSelector.onData3IdChange}
        />

        {/* <CarDownloadButton onClick={handleShowPdf} sx={{ ml: "auto" }}>
          Download PDF
        </CarDownloadButton> */}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {(data.item1 || data.item2 || data.item3) && (
          <>
            <Box
              sx={{
                mt: -2,
                ml: "auto",
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
              }}
            >
              <InternalUse />
              <Typography variant="h6SRegular" sx={{ fontStyle: "italic" }}>
                Start Date {formatDate(data.startDate)}
              </Typography>
            </Box>
            <ChartIndexCompare
              sx={{ mt: 1.5 }}
              item1={data.item1}
              item2={data.item2}
              item3={data.item3}
              isWhiteContext={false}
            />
            <TableIndexCompare
              sx={{ mt: 6 }}
              item1={data.item1}
              item2={data.item2}
              item3={data.item3}
              isWhiteContext={false}
            />
          </>
        )}
      </Box>
    </TablePlaceHolder>
  );
});
